import { MouseEventHandler } from 'react';
import { LegacyIcon } from '../LegacyIcon';
import { EventClickElement } from '@tuic/tracking';

/**
 * Renders a button that scrolls to the top of the page when clicked.
 */
const ScrollToTopButton = () => {
  const handleClick: MouseEventHandler = ev => {
    ev.preventDefault();
    if (!window) {
      return;
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };
  return <button data-track-click-element={EventClickElement.Button} data-track-click-label="scroll-to-top" aria-label="scroll-to-top" className="w-full appearance-none border-0 px-[1.875rem] py-[1.5625rem] text-center" onClick={handleClick} data-sentry-component="ScrollToTopButton" data-sentry-source-file="scroll-to-top-button.tsx">
      <LegacyIcon name="arrow-up" size={30} data-sentry-element="LegacyIcon" data-sentry-source-file="scroll-to-top-button.tsx" />
    </button>;
};
export default ScrollToTopButton;